import React, { FC } from 'react';
import styled from 'styled-components';

import ProgressBar, { ProgressContainer } from 'components/ProgressBar';

interface ChangeButtonProps {
  icon?: any;
  color?: string;
  backgroundColor?: string;
  onClick: () => void;
  id?: string;
  width?: number;
  marginTop?: string;
}

export const ChangeButton: FC<ChangeButtonProps> = ({
  onClick,
  id,
  backgroundColor,
  color,
  icon,
  width,
  marginTop,
  children
}) => (
  <InstallButton
    backgroundColor={backgroundColor}
    id={id}
    aria-label={id}
    width={width}
    marginTop={marginTop}
    onClick={onClick}
  >
    { typeof icon !== 'undefined' && <IconContainer src={icon} /> }
    <ButtonTextContainer color={color}>
      <b>{children}</b>
    </ButtonTextContainer>
  </InstallButton>
);

interface LoadingBarProps {
  color?: string;
}

export const LoadingBar: FC<LoadingBarProps> = ({ color }) => (
  <div id="loading" aria-label="loading">
    <ProgressBar animation={true} color={color} />
  </div>
);

interface ProgressProps {
  progress?: number;
  color?: string;
}

export const Progress: FC<ProgressProps> = ({ progress, color }) => (
  <div id="progress" aria-label="progress">
    <ProgressContainer>
      <ProgressBar percentage={progress ? progress : 0} color={color} />
    </ProgressContainer>
  </div>
);

export const Button = styled.div`
  cursor: pointer;
  margin: 0;
  outline: 0;
  overflow: hidden;
  text-align: center;
  border-radius: 16px;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.28px;
  text-transform: uppercase;
  min-width: 140px;
  min-height: 50px;
`;

export const DisabledButton = styled(Button)`
  background-color: #f6f6f6;
  color: #112530;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: none;
`;

interface InstallButtonProps {
  backgroundColor?: string;
  width?: number;
  marginTop?: string;
}

export const InstallButton = styled(Button)<InstallButtonProps>`
  background-color: ${({backgroundColor}) => backgroundColor};
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  -webkit-tap-highlight-color: transparent;

  ${({width}) => width ? `width: ${width}px;` : ''}
  ${({marginTop}) => marginTop ? `margin-top: ${marginTop};` : ''}
`;

export const IconContainer = styled.img`
  width: 20px;
  padding-right: 10px;
`;

interface ButtonTextContainerProps {
  color?: string;
}

export const ButtonTextContainer = styled.div<ButtonTextContainerProps>`
  font-size: 14px;
  letter-spacing: -0.28px;
  text-transform: uppercase;
  color: ${({color}) => color};
`;

export const RowsContainer = styled.div`
  width: 100%;
  margin: 25px 30px 5px 30px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
  margin-bottom: 20px;
`;

interface RowTitleProps {
  bold: boolean;
}

export const RowTitle = styled.div<RowTitleProps>`
  flex-grow: 1;
  font-size: 14px;
  color: #000;
  ${({ bold, theme }) => bold && `font-family: ${theme.fontBold}`};
`;
